import { UseQueryOptions, useMutation } from '@tanstack/react-query-v4'
import { ApiError, QueryKey } from '@api'
import { useApi } from '@api/useApi.hook'
import { appConfig } from '@config'
import { useToast } from '@components/shared/toaster/toaster.ts'
import { queryClient } from 'src/providers/react-query'
import { useAuth } from '@domain/auth/Auth.context'
import { isStatusCode403 } from '@utils/statusCode.utils'
import get from 'lodash/get'

export const useDeleteMyAvatar = () => {
  const [auth] = useAuth()
  const { toast } = useToast()

  const { deleteReq } = useApi()
  const userUuid = get(auth, 'user.uuid', '')
  const avatarEndpoint = appConfig.endpoints.v1.users.avatar.replace(/:userId/, userUuid)
  const { mutate, isLoading } = useMutation(deleteReq(avatarEndpoint))
  const deleteAvatar = (options?: UseQueryOptions) => {
    mutate(undefined, {
      onSuccess: (data) => {
        if (options?.onSuccess) {
          options?.onSuccess(data)
        }
        toast({
          title: 'Your profile pic has been deleted',
          variant: 'success',
        })
        queryClient.invalidateQueries({ queryKey: [QueryKey.Me] })
      },
      onError: (error) => {
        const err = error as ApiError
        if (!isStatusCode403(err.status)) {
          toast({ title: err.message, variant: 'error' })
        }
      },
    })
  }

  return {
    deleteAvatar,
    isLoading,
  }
}
